import { Typography } from '@mui/material';
import RenterInviteDrawerForm from './RenterInviteDrawerForm';
import { useRenterInviteController } from './useRenterInvite.controller';

export type RenterInviteDrawerFormContentProps = {
  onSuccess?: () => void;
};

const RenterInviteDrawerFormContent = ({ onSuccess }: RenterInviteDrawerFormContentProps) => {
  const { user, errorMsg, isSmbRenterInvites, useNewForm, customCoverageDisabled, onSubmit } =
    useRenterInviteController({ onSuccess });

  return (
    <>
      <Typography mb={3} fontSize={'16px !important'} letterSpacing={0}>
        Please fill out your renter's information below, and we will send them an invitation to
        apply using the email address provided.
      </Typography>
      <RenterInviteDrawerForm
        user={user}
        onSubmit={onSubmit}
        errorMsg={errorMsg}
        newCoveragesEnabled={useNewForm}
        customCoverageDisabled={customCoverageDisabled}
        isSmbRenterInvites={isSmbRenterInvites}
      />
    </>
  );
};

export default RenterInviteDrawerFormContent;
